import axios from './base'

const url = {
  add: '/api/opened',
  query: '/api/opened',
  removeByNotebookId: (notebookId) => `/api/opened/notebooks/${notebookId}`,
  removeByNoteId: (noteId) => `/api/opened/notes/${noteId}`
}

export default {
  async add ({ notebookId, noteId }) {
    const result = await axios.post(url.add, {
      notebookId,
      noteId
    })
    return result
  },
  async query () {
    return axios.get(url.query)
  },
  async removeByNoteId (noteId) {
    return axios.delete(url.removeByNoteId(noteId))
  },
  async removeByNotebookId (notebookId) {
    return axios.delete(url.removeByNotebookId(notebookId))
  }
}
